module.exports = __webpack_public_path__ + "static/fipcmintorganic3-fcbbcbd84b1c77640062fa32c646cf6d.jpeg";